module.exports = __webpack_public_path__ + "public/images/forbes@2x.80ad4e2f747b16daee0ff880656ea46b.png";